import script from "./Escala.vue?vue&type=script&setup=true&lang=js"
export * from "./Escala.vue?vue&type=script&setup=true&lang=js"

import "./Escala.vue?vue&type=style&index=0&id=2fa43c3f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa43c3f"]])

export default __exports__